"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const theme_1 = require("../../styles/theme");
const RootWrapperWeb = props => {
    const classes = useStyles();
    const { children } = props;
    return react_1.default.createElement("div", { className: classes.fieldWrapper }, children);
};
const useStyles = (0, styles_1.makeStyles)(theme => ({
    wrapper: {
        width: '100%',
    },
    fieldWrapper: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        gap: 10,
        backgroundColor: theme_1.colors.white,
    },
}));
exports.default = RootWrapperWeb;
//# sourceMappingURL=RootWrapperWeb.js.map